
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetNtype2On as ObiMosfetNtype2OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ntype-2-on.js';
 
 
 

 
 export const ObiMosfetNtype2On = createComponent({
   react: React,
   tagName: 'obi-mosfet-ntype-2-on',
   elementClass: ObiMosfetNtype2OnElement,
   events: {
     
   }
  });
 
 